import { Icon } from './Icon.js';
import { Progress } from './Progress.js';
import type { ApplicantForm } from './useApplicantForm.js';

/**
 * The top of each step (F10 P6): labelled progress, "Step 2 of 4", the title
 * and the line explaining the step. Shared by the public form and Try it out.
 */
export function StepHeader({ flow }: { flow: ApplicantForm }) {
  const page = flow.pages[flow.step];
  const { step, total, labels, canPick, pick } = flow.progress;
  return (
    <>
      <Progress step={step} total={total} labels={labels} canPick={canPick} onPick={pick} />
      <div className="rdr-step-label">
        Step {step + 1} of {total}
      </div>
      <h2 className="rdr-step-title">{flow.isReview ? 'Check and send' : (page?.title ?? flow.form.name)}</h2>
      {flow.isReview ? (
        <p className="rdr-step-sub">Check your answers. Use Change to fix anything, then send it to us.</p>
      ) : (
        page?.intro && <p className="rdr-step-sub">{page.intro}</p>
      )}
    </>
  );
}

/** "There are 2 things to fix", each linking to its question. */
export function ErrorSummary({ flow }: { flow: ApplicantForm }) {
  const list = flow.errorList;
  if (!list.length) return null;
  const go = (id: string) => {
    const el = document.getElementById(`q-${id}`);
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el?.querySelector<HTMLElement>('input, select, textarea, button')?.focus({ preventScroll: true });
  };
  return (
    <div className="rdr-error-summary" role="alert">
      <strong>
        <Icon name="alert" size={14} /> {list.length === 1 ? 'There’s 1 thing to fix' : `There are ${list.length} things to fix`}
      </strong>
      <ul>
        {list.map((e) => (
          <li key={e.id}>
            <a
              href={`#q-${e.id}`}
              onClick={(ev) => {
                ev.preventDefault();
                go(e.id);
              }}
            >
              {e.message}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
